import { dataService } from '@app/modules/data';
import { DataObject, ObjectOptions } from './base';

import { Place } from './place';

export interface _PlaceAvailability {
    status: string;
    place: number;
    day_of_week: number;
    start_time: string;
    end_time: string;
}

interface _PlaceAvailabilityData extends _PlaceAvailability {
    objid?: number;
    _uuid?: string;
    created?: Date;
    updated?: Date;
}

abstract class PlaceAvailabilityData extends DataObject {
    protected _availability: _PlaceAvailabilityData = {
        status: null,
        place: null,
        day_of_week: null,
        start_time: null,
        end_time: null
    };

    constructor(table: string, objid: string, data: dataService, objoptions: ObjectOptions) {
        super(table, objid, data, objoptions);
        this._availability.created = new Date();
        this._availability.updated = new Date();
    }

    get created() { return this._availability.created; }
    get updated() { return this._availability.updated; }

    get place(): Place {
        return this._children['place'] || null;
    }

    set place(value: Place) {
        if (this.SetChild('place', value, 'place')) {
            this.ToUpdate = true;
        }
    }

    get status(): string { return this._availability.status; }
    get day_of_week(): number { return this._availability.day_of_week; }
    get start_time(): string { return this._availability.start_time; }
    get end_time(): string { return this._availability.end_time; }

    protected get Change() {
        return {
            status: this._availability.status,
            place: this._availability.place,
            day_of_week: this._availability.day_of_week,
            start_time: this._availability.start_time,
            end_time: this._availability.end_time
        };
    }

    protected get Depend() {
        return {
            place: { item: this.place, relation_info: { to: 'availability', by: 'place' } }
        };
    }

    protected get Children() {
        return [];
    }

    private _patchData(r: _PlaceAvailability) {
        let _toUpdate = false;
        _toUpdate = this.patchValue(this._availability, 'status', r['status']) || _toUpdate;
        _toUpdate = this.patchValue(this._availability, 'place', r['place']) || _toUpdate;
        _toUpdate = this.patchValue(this._availability, 'day_of_week', r['day_of_week']) || _toUpdate;
        _toUpdate = this.patchValue(this._availability, 'start_time', r['start_time']) || _toUpdate;
        _toUpdate = this.patchValue(this._availability, 'end_time', r['end_time']) || _toUpdate;
        return _toUpdate;
    }

    set Data(r: _PlaceAvailability) {
        this.patchValue(this._availability, 'created', r['created']);
        this.patchValue(this._availability, 'updated', r['updated']);
        if (this._patchData(r)) {
            this.ToUpdate = true;
        }
    }

    get Info() { return this._availability; }

    set Info(value) {
        this._doPatchValues(value);
    }

    private _doPatchValues(r: _PlaceAvailability) {
        this._patchData(r);
        if (r && r['place']) {
            const _objid = r['place'].toString();
            this.SetChild('place', new Place(_objid, this.data, this._objoptions), 'place');
        } else {
            this.SetChild('place', null, 'place');
        }
    }

    private _ddbb(info): _PlaceAvailabilityData {
        return {
            objid: info['objid'] ? parseInt(info['objid']) : null,
            created: info['created'] ? new Date(Date.parse(this.mysqlToDateStr(info['created']))) : new Date(),
            updated: info['updated'] ? new Date(Date.parse(this.mysqlToDateStr(info['updated']))) : new Date(),
            status: info['status'] || 'AC',
            place: info['place'] ? parseInt(info['place']) : null,
            day_of_week: info['day_of_week'] != null ? parseInt(info['day_of_week']) : null,
            start_time: info['start_time'] || null,
            end_time: info['end_time'] || null
        };
    }

    protected _OnUpdate(info) {
        const r = this._ddbb(info);
        this.patchValue(this._availability, 'objid', r['objid']);
        this.patchValue(this._availability, 'created', r['created']);
        this.patchValue(this._availability, 'updated', r['updated']);
        this._doPatchValues(r);
    }
}

export class PlaceAvailability extends PlaceAvailabilityData {
    constructor(objid: string, data: dataService, objoptions: ObjectOptions = null) {
        super('PLACEAVAILABILITY', objid, data, objoptions);
    }

    Copy(store: Array<DataObject> = []): PlaceAvailability {
        return this._Copy(store) as PlaceAvailability;
    }
}
